import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import DescriptionIcon from '@mui/icons-material/Description';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Typography } from "@mui/material";
import { reset as userReset } from "../../redux/userSlice";
import { reset as insuranceReset } from "../../redux/insuranceSlice";
import { reset as stripeReset } from "../../redux/stripeSlice";

import Question from '../../components/Question';
import InfoCard from "../../components/InfoCard";

export default function PhotosThankYou(props) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(userReset());
        dispatch(insuranceReset());
        dispatch(stripeReset());
    }, [dispatch]);


    return (
        <Question
            noBack={true}
            backgroundColor="#82B1FF33"
            componentHeight="100vh"
            title="Thank you! Your photos have been added."
            input={
                <>
                    <Typography variant="h6" fontWeight={400} mt={2} mb={1}>
                        What to Expect Next
                    </Typography>

                    <InfoCard
                        icon={DescriptionIcon}
                        title="Your Case Review & Treatment Plan"
                        description="A board-certified dermatologist will review your case and provide a diagnosis with a personalized treatment plan within 24 hours."
                    />

                    <InfoCard
                        icon={NotificationsActiveIcon}
                        title="Updates & Notifications"
                        description="You'll receive a text message as soon as your treatment plan is ready. In the meantime, you can safely close this window."
                    />
                </>
            }
            {...props}
        />
    );
}
